import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { LocationsDTO } from 'models'
import { FormThirdGuarantorKeys } from './types'

interface Schema {
   id: FormThirdGuarantorKeys
}

export const FormThirdGuarantorValue = (
   location: LocationsDTO[]
): {
   input?: InputBuildProps & Schema
   select?: SelectBuildProps & Schema
   layout: LayoutProps
}[] => [
      {
         input: {
            id: 'nome',
            label: 'Nome do terceiro garantidor',
            required: false, // Pode ajustar para true se for obrigatório
            maxLength: 128
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
         }
      },
      {
         input: {
            id: 'email',
            label: 'Email',
            required: false,
            maxLength: 128
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
         }
      },
      {
         select: {
            id: 'tipoDocumento',
            label: 'Doc. terceiro garantidor',
            optionsType: 'doc',
            required: false
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
         }
      },
      {
         input: {
            id: 'documento',
            label: 'Nº do documento',
            inputMode: 'numeric',
            maskReplace: 'registro',
            required: false
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
         }
      },
      {
         input: {
            id: 'endereco.cep',
            label: 'CEP',
            maskReplace: 'cep',
            inputMode: 'numeric',
            required: false
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
         }
      },
      {
         select: {
            id: 'endereco.municipio',
            label: 'Município',
            options: location?.map(({ municipio, codigoTomDetran }) => ({
               text: municipio,
               value: `${String(codigoTomDetran)}|${municipio}`
            })),
            isSearching: true,
            required: false,
            isDisable: true
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
         }
      },
      {
         select: {
            id: 'endereco.uf',
            label: 'UF',
            required: false,
            optionsType: 'uf',
            isSearching: true,
            isDisable: true
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
         }
      },
      {
         input: {
            id: 'endereco.bairro',
            label: 'Bairro',
            isSearching: true,
            required: false
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
         }
      },
      {
         input: {
            id: 'endereco.logradouro',
            label: 'Logradouro',
            isSearching: true,
            required: false
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 10 }
         }
      },
      {
         input: {
            id: 'endereco.numero',
            label: 'Número',
            isSearching: true,
            required: false
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 2 }
         }
      },
      {
         input: {
            id: 'telefone',
            label: 'Telefone',
            inputMode: 'numeric',
            maskReplace: 'contato',
            required: false
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 5 }
         }
      },
      {
         input: {
            id: 'endereco.complemento',
            label: 'Complemento ou referência'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 7 }
         }
      }
   ]